export default __webpack_public_path__ + "static/media/formas-digitales-banner-soluciones.6cec9a4e.png";